module.exports = __webpack_public_path__ + "img/dash-group.93074c1b.svg";